<template>
  <SfTabs :open-tab="1" class="shop-products">
    <SfTab v-if="isChangeProduct == false" title="Новости магазина">
      <div class="message" style="display: flex; align-items: center;">
        <SfButton @click="productData = productDataEmpty; isChangeProduct = true" style="margin-left: 15px;">Добавить новость</SfButton>
      </div>
      <SfLoader :class="{ loading }" :loading="loading">
        <SfTable>
          <SfTableHeading>
            <SfTableHeader>Изображение</SfTableHeader>
            <SfTableHeader>Заголовок</SfTableHeader>
            <SfTableHeader>Краткое описание</SfTableHeader>
            <SfTableHeader>Просмотры</SfTableHeader>
            <SfTableHeader>
              <SfButton class="sf-button--text">Действия</SfButton>
            </SfTableHeader>
          </SfTableHeading>
          <SfTableRow v-for="review in products" :key="review.id">
            <SfTableData><img width="150px" :src="getImage(review.image)"></SfTableData>
            <SfTableData>{{ review.name }}</SfTableData>
            <SfTableData>{{ review.short_description }}</SfTableData>
            <SfTableData>{{ review.view }}</SfTableData>
            <SfTableData>
              <SfButton @click="productData = review; isChangeProduct = true" class="sf-button--text">Изменить</SfButton>
              <br>
              <SfButton style="color: red;" @click="deleteProduct(review.id)" class="sf-button--text">Удалить</SfButton>
            </SfTableData>
          </SfTableRow>
        </SfTable>
      </SfLoader>
    </SfTab>
    <SfTab v-else :title="productData.id ? 'Изменить новость' : 'Добавить продукт'">
      <p class="message" style="display: flex; align-items: center;">
        <SfButton @click="isChangeProduct = false; getProducts()">Назад</SfButton>
      </p>
      <form class="form" @submit="updateInfo">
        <SfInput
          v-model="productData.name"
          style="width: 100%; max-width: 100%;"
          name="name"
          label="Название"
          required
          class="form__element"
        />
        <SfTextarea
          style="width: 100%"
          v-model="productData.short_description"
          name="short_description"
          label="Краткое описание"
          class="form__element"
        />
        <quill-editor
          style="width: 100%; max-width: 100%;"
          ref="myQuillEditor"
          v-model="productData.description"
        />
        <div style="width: 100%; max-width: 100%; display: flex; justify-content: space-between; align-items: center; align-items: flex-start;">
          <img style="width: 10%;" :src="getImage(productData.image)" alt="">  
          <SfInput
            type="file"
            name="image"
            label="Изображение"
            :required="productData.image ? false : true"
            class="form__element"
            style="flex: 1; margin-left: 15px;"
          />
        </div>
        <SfButton class="form__button classic-button"
          >Сохранить
        </SfButton>
      </form>
      <p class="notice">
        Используя наш сайт вы соглашаетесь с нашей
        <router-link :to="{ name: 'page', params: { slug: 'privacy' } }">
          политикой конфиденциальности и обработки данных.
        </router-link>
      </p>
    </SfTab>
  </SfTabs>
</template>
<script>
import { SfTabs, SfLoader, SfButton, SfInput, SfTextarea, SfTable } from "@storefront-ui/vue";
import apiRequest from '../../shared/apiRequest'

import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "PersonalDetails",
  components: {
    SfTabs,
    SfLoader,
    SfButton,
    SfTable,
    SfInput, SfTextarea,
    quillEditor
  },
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isChangeProduct: false,
      loading: true,
      pagination: {
        totalItems: 10,
        totalPages: 3,
        currentPage: 1,
      },
      products: [],
      productDataEmpty: {
        name: "",
        image: '',
        short_description: '',
        description: '',
      },
      productData: {
        name: "",
        image: '',
        short_description: '',
        description: '',
      },
    };
  },
  watch: {
    account: {
      handler(value) {
        this.name = value.name;
        this.phone = value.phone;
        this.email = value.email;
      },
      immediate: true,
    },
  },

  mounted() {
    this.getProducts()
  },
  methods: {
    getProducts() {
      const data = {};

      data.page = this.pagination.currentPage

      apiRequest.get(`/users/${this.account.id}/media`, {
        params: data
      })
          .then((result) => {
            const { data, current_page, last_page, total } = result.data;
            this.products = data;

            this.pagination.totalItems = total;
            this.pagination.totalPages = last_page;
            this.pagination.currentPage = current_page;

            this.loading = false;
          })
          .catch((error) => {
            console.log(error)
          });
    },
    deleteProduct(id) {
      apiRequest.delete(`/users/${this.account.id}/media/${id}`)
          .then(() => {
            this.getProducts()
          })
          .catch((error) => {
            console.log(error)
          });
    },
    setCurrentPage(value) {
      window.scrollTo(0, 0)
      this.pagination.currentPage = value;
      this.getProducts()
    },
    getImage(image) {
      const imageCont = image.split('.');
      return `${process.env.VUE_APP_STORAGE}/${imageCont[0]}-cropped.${imageCont[1]}`
    },
    updateInfo(e) {
      e.preventDefault();
      console.log(e.target)

      var formData = new FormData(e.target);

      for(let name in this.productData) {
          formData.append(name, this.productData[name])
        
      }
      
      let url = `/users/${this.account.id}/media`
      if(this.productData.id) {
        url = `/users/${this.account.id}/media/${this.productData.id}`
      }
      apiRequest.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((result) => {
          this.productData = result.data
          alert('Успешно обновлено');
        })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/vue/styles";
.form {
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &__element {
    margin: 0 0 var(--spacer-lg) 0;
    @include for-desktop {
      flex: 0 0 100%;
    }
    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }
      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-lg);
        }
      }
    }
    textarea {
      width: 100%;
    }
  }
  &__button {
    --button-width: 100%;
    @include for-desktop {
      --button-width: 17.5rem;
    }
  }
}
.message {
  margin: 0 0 var(--spacer-xl) 0;
  color: var(--c-dark-variant);
}
.notice {
  margin: var(--spacer-base) 0 0 0;
  font-size: var(--font-size--sm);
}
a {
  color: var(--c-primary);
  text-decoration: none;
  &:hover {
    color: var(--c-text);
  }
}
</style>

<style lang="scss">
.multiselect__tags {
  background: hsla(0,0%,80%,.14901960784313725);
    padding-left: 10px;
    border: none;
    height: var(--select-height, 4.25rem);
}
.multiselect__tag {
  background-color: #f5b800ba;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #a17900ba;
}

.multiselect__tag-icon:after {
  color: #443300ba;
}

.multiselect__option--highlight {
  background: #f5b800ba;
}

.multiselect__option::after {
  background: #a17900ba;
}
.shop-products {
  .products {
    box-sizing: border-box;
    flex: 1;
    margin: 0;
    &__grid,
    &__list {
      display: flex;
      flex-wrap: wrap;
    }
    &__product-card {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &__product-card-horizontal {
      flex: 0 0 100%;
    }
    &__slide-enter {
      opacity: 0;
      transform: scale(0.5);
    }
    &__slide-enter-active {
      transition: all 0.2s ease;
      transition-delay: calc(0.1s * var(--index));
    }
    @include for-desktop {
      &__grid {
        margin: var(--spacer-sm) 0 0 var(--spacer-sm);
      }
      &__pagination {
        display: flex;
        justify-content: flex-start;
        margin: var(--spacer-xl) 0 0 0;
      }
      &__product-card-horizontal {
        margin: var(--spacer-lg) 0;
      }
      &__product-card {
        flex: 1 1 25%;
      }
      &__list {
        margin: 0 0 0 var(--spacer-sm);
      }
    }
    &__show-on-page {
      display: flex;
      justify-content: flex-end;
      align-items: baseline;
      &__label {
        font-family: var(--font-family--secondary);
        font-size: var(--font-size--sm);
      }
    }
  }

  .sf-select {
    width: 100%;
  }

  .sf-product-card__wishlist-icon {
    display: none;
  } 

  .form__element {
    textarea {
      width: 100%;
    }
  } 
}

.product__select {
  &-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.1);
    padding: var(--product-card-padding, var(--spacer-xs));
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.active {
      background-color: rgba(0,0,0,0.2);
    }
  }  
}

</style>